import React from 'react';
import { useLocation } from 'react-router';
import { useRouteHydration } from '@/utils/routeState/useRouteHydration';
import { useStore } from '@/utils/storeUtils';

// A generic wrapper that determines the routeKey from the URL
export const GenericRouteHydrator = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // Extract routeKey from pathname like `/en-us/checkout` => `checkout`
  const pathname = location.pathname || '';
  const parts = pathname.split('/').filter(Boolean); // removes empty strings

  const routeKey = parts[1] || 'unknown'; // e.g., '/en-us/checkout' => 'checkout'

  useRouteHydration(routeKey);

  const [storeState] = useStore();

  if (!storeState.hydrated?.[routeKey]) return null;

  return <>{children}</>;
};
